var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.widget.type === "grid-col"
    ? _c(
        "el-col",
        _vm._b(
          {
            key: _vm.widget.id,
            staticClass: "grid-cell",
            class: [_vm.selected ? "selected" : "", _vm.customClass],
            style: _vm.colHeightStyle,
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.selectWidget(_vm.widget)
              },
            },
          },
          "el-col",
          _vm.layoutProps,
          false
        ),
        [
          _c(
            "draggable",
            _vm._b(
              {
                attrs: {
                  list: _vm.widget.widgetList,
                  handle: ".drag-handler",
                  move: _vm.checkContainerMove,
                },
                on: {
                  end: function (evt) {
                    return _vm.onGridDragEnd(evt, _vm.widget.widgetList)
                  },
                  add: function (evt) {
                    return _vm.onGridDragAdd(evt, _vm.widget.widgetList)
                  },
                  update: _vm.onGridDragUpdate,
                },
              },
              "draggable",
              { group: "dragGroup", ghostClass: "ghost", animation: 200 },
              false
            ),
            [
              _c(
                "transition-group",
                {
                  staticClass: "form-widget-list",
                  attrs: { name: "fade", tag: "div" },
                },
                [
                  _vm._l(_vm.widget.widgetList, function (subWidget, swIdx) {
                    return [
                      "container" === subWidget.category
                        ? [
                            _c(subWidget.type + "-widget", {
                              key: subWidget.id,
                              tag: "component",
                              attrs: {
                                widget: subWidget,
                                designer: _vm.designer,
                                "parent-list": _vm.widget.widgetList,
                                "index-of-parent-list": swIdx,
                                "parent-widget": _vm.widget,
                              },
                            }),
                          ]
                        : [
                            _c(subWidget.type + "-widget", {
                              key: subWidget.id,
                              tag: "component",
                              attrs: {
                                field: subWidget,
                                designer: _vm.designer,
                                "parent-list": _vm.widget.widgetList,
                                "index-of-parent-list": swIdx,
                                "parent-widget": _vm.widget,
                                "design-state": true,
                              },
                            }),
                          ],
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.designer.selectedId === _vm.widget.id &&
          _vm.widget.type === "grid-col"
            ? _c("div", { staticClass: "grid-col-action" }, [
                _c("i", {
                  staticClass: "el-icon-back",
                  attrs: {
                    title: _vm.i18nt("designer.hint.selectParentWidget"),
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.selectParentWidget(_vm.widget)
                    },
                  },
                }),
                _vm._v(" "),
                !!_vm.parentList && _vm.parentList.length > 1
                  ? _c("i", {
                      staticClass: "el-icon-top",
                      attrs: { title: _vm.i18nt("designer.hint.moveUpWidget") },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.moveUpWidget()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.parentList && _vm.parentList.length > 1
                  ? _c("i", {
                      staticClass: "el-icon-bottom",
                      attrs: {
                        title: _vm.i18nt("designer.hint.moveDownWidget"),
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.moveDownWidget()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-copy-document",
                  attrs: { title: _vm.i18nt("designer.hint.cloneWidget") },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.cloneGridCol(_vm.widget)
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-delete",
                  attrs: { title: _vm.i18nt("designer.hint.remove") },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.removeWidget(_vm.widget)
                    },
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.designer.selectedId === _vm.widget.id &&
          _vm.widget.type === "grid-col"
            ? _c("div", { staticClass: "grid-col-handler" }, [
                _c("i", [
                  _vm._v(
                    _vm._s(_vm.i18nt("designer.widgetLabel." + _vm.widget.type))
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }